(function ($) {
	class W4D_CjeniciViewer {
		constructor(element) {
			this.$el = $(element);
			this.pending = {};
			this.initSelectors();
			this.bindEvents();
		}

		initSelectors() {
			this.tabs = this.$el.find('.cjenici-tab');
			this.contentArea = this.$el.find('.cjenici-content');
			this.currentDate = this.$el.find('.cjenici-current-date');
			this.popoverPanel = this.$el.find('.filter__panel');
			this.popoverTrigger = this.$el.find('.filter__trigger');
		}

		bindEvents() {
			if (this.tabs.length) {
				this.tabs.on('click', (e) => {
					this.handleTabClick($(e.currentTarget));
				});

				this.tabs.on('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						this.handleTabClick($(e.currentTarget));
					}
				});
			}

			if (this.popoverPanel.length && this.popoverTrigger.length) {
				this.popoverPanel[0].addEventListener('toggle', (event) => {
					this.popoverTrigger.attr('aria-expanded', event.newState === 'open' ? 'true' : 'false');
				});
			}
		}

		handleTabClick($clickedTab) {
			const targetId = $clickedTab.attr('data-target');
			const targetDate = $clickedTab.attr('data-date');
			const $targetPanel = this.$el.find('#' + targetId);

			this.tabs.removeClass('is-selected').attr('aria-selected', 'false');
			$clickedTab.addClass('is-selected').attr('aria-selected', 'true');
			this.currentDate.text(targetDate);

			const popoverElement = this.popoverPanel[0];
			if (popoverElement && popoverElement.hidePopover) {
				popoverElement.hidePopover();
			}

			if ($targetPanel.length) {
				this.showPanel($targetPanel);
			} else {
				this.fetchPanel(targetDate, targetId);
			}
		}

		showPanel($panel) {
			this.$el.find('.cjenici-panel').removeClass('active');
			$panel.addClass('active');
		}

		isSelected(targetId) {
			return this.tabs.filter('.is-selected').attr('data-target') === targetId;
		}

		fetchPanel(date, targetId) {
			// Request for this date is already in flight
			if (this.pending[targetId]) {
				return;
			}

			this.pending[targetId] = true;
			this.contentArea.addClass('is-loading');

			$.ajax({
				url: w4d_frontend_ajax.ajax_url,
				method: 'POST',
				data: {
					action: 'w4d_get_cjenici_date',
					nonce: w4d_frontend_ajax.nonce,
					date: date,
				},
				success: (response) => {
					if (!response?.success || !response.data?.html || response.data.date !== date) {
						console.error(response?.data?.message || 'Error fetching cjenici data.');
						return;
					}

					// Force the expected id so later clicks find the cached panel
					const $panel = $(response.data.html).filter('.cjenici-panel').first();
					if (!$panel.length || this.$el.find('#' + targetId).length) {
						return;
					}

					$panel.attr('id', targetId).removeClass('active');
					this.contentArea.append($panel);

					if (this.isSelected(targetId)) {
						this.showPanel($panel);
					}
				},
				error: () => {
					console.error('Failed to fetch cjenici data');
				},
				complete: () => {
					delete this.pending[targetId];

					if ($.isEmptyObject(this.pending)) {
						this.contentArea.removeClass('is-loading');
					}
				},
			});
		}
	}

	$(document).ready(() => {
		$('.cjenici-layout').each((index, el) => {
			new W4D_CjeniciViewer(el);
		});
	});
})(jQuery);
